import { useQueryUpdate } from '@shared/hooks'
import { defaultFilters } from '@shared/utils'
import { DatePicker } from 'antd/lib'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

import type { RangePickerProps } from 'antd/lib/date-picker'

const { RangePicker } = DatePicker

type Props = {
  fromParam?: string
  toParam?: string
  defaultValueDate?: [string, string]
} & RangePickerProps

export const RangePickerFilter = ({
  fromParam = 'startDate',
  toParam = 'endDate',
  defaultValueDate,
  ...props
}: Props) => {
  const { params, updateQuery } = useQueryUpdate()
  const { t } = useTranslation()
  const { styles } = useStyles()

  const queryFromParam = params?.[fromParam]
  const queryToParam = params?.[toParam]

  const pickerValue = queryFromParam &&
    queryToParam && [dayjs(queryFromParam), dayjs(queryToParam)]

  const defaultPickerValue = defaultValueDate
    ? [dayjs(defaultValueDate[0]), dayjs(defaultValueDate[1])]
    : undefined

  return (
    <RangePicker
      value={pickerValue || defaultPickerValue}
      className={styles.rangePicker}
      placeholder={[t('date_start'), t('date_end')]}
      onChange={(_, [fromPickerValue, toPickerValue]) =>
        updateQuery({
          [fromParam]: fromPickerValue,
          [toParam]: toPickerValue,
          page: defaultFilters.page
        })
      }
      {...props}
    />
  )
}
